import { ChannelCategoryEntity } from '../../domain/entities/ChannelCategory'
import { ChannelCategory } from '../../shared/types/ChannelCategory'

export type ChannelCategoryAPIModel = ChannelCategory

export const mapApiToEntity = (api: ChannelCategoryAPIModel): ChannelCategoryEntity =>
  ChannelCategoryEntity.create({
    uuid: api.uuid,
    slug: api.slug,
    name: api.name,
    channelsCount: api.channelsCount,
  })

export const mapEntityToDTO = (entity: ChannelCategoryEntity): ChannelCategory => ({
  uuid: entity.uuid,
  slug: entity.slug,
  name: entity.name,
  channelsCount: entity.channelsCount,
})
